import React, { useState } from "react";
import { X } from "lucide-react";
import { api } from "@/platform/api";
import { Button, TextField } from "@/platform/components/primitives";

export default function NewProjectModal({ onClose, onCreated }) {
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!name.trim()) { setError("Give your project a name."); return; }
    if (!url.trim()) { setError("Enter the website URL."); return; }
    setError(""); setLoading(true);
    try {
      const res = await api.post("/api/projects", { name: name.trim(), url: url.trim() });
      onCreated?.(res);
    } catch (err) { setError(err.message); setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-5" data-testid="new-project-modal">
      <div className="absolute inset-0 bg-black/55 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-[460px] animate-in fade-in zoom-in-95 duration-300 rounded-2xl border border-[#242A38] bg-[#151A24] p-7 shadow-2xl">
        <button onClick={onClose} className="absolute right-4 top-4 text-[#6E7686] hover:text-[#AAB1BF]" aria-label="Close"><X className="h-5 w-5" /></button>
        <h2 className="text-[22px] font-semibold tracking-tight text-[#F4F5F8]">Create a project</h2>
        <p className="mt-1.5 text-[14px] text-[#98A0B0]">Point Pinlayr at the website you want to review.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <TextField id="pname" label="Project name" placeholder="Riversol Website Revamp" value={name} onChange={(e) => setName(e.target.value)} autoFocus data-testid="project-name" />
          <TextField id="purl" label="Website URL" placeholder="https://www.riversol.com" value={url} onChange={(e) => setUrl(e.target.value)} error={error} data-testid="project-url" />
          <Button type="submit" loading={loading} data-testid="project-submit">Create project</Button>
        </form>
      </div>
    </div>
  );
}
